import React, { createContext, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Grid } from "@mui/material";
import { Convert, DefaultArrayEmpty, FnAxios, FnDialog, I18n, formatNumber, getMonthDifference } from "utilities/utilities";
import InputNumberItem from "components/Input/InputNumber";
import { BtnAdd, BtnDelete } from "components/Button/ButtonAll";
import moment from "moment";
import DateRangeProject from "view/FrontEnd/Project/components/DateRange";
import NumberInputCustom from "../../components/NumberInputCustom";
import { parseFloatCheckValue } from "view/Backend/IncomeExpenses/Ticket/fnTickit";

export default function SpendingPlanDuration(props) {
    const {
        nYear,
        formDuration,
        onAddDuration,
        onDeleteDuration,
        arrDuration = [],
        dataRowProject,
        isPermission,
        nBudgetAll,
        dStart,
        dEnd,
        trigger,
    } = props;

    const DialogFn = FnDialog();
    const [nTrigger, setnTrigger] = useState(trigger);

    const handleChangeBudget = (nID) => {
        //#region แบบทุกกิจกรรม
        // // let clone = [...dataRowProject];
        // let _dataRowProject = [].concat(...dataRowProject.map(m => m.lstProjectSpendingPlan))
        // let clone = [..._dataRowProject];
        // let lstData = [].concat(...clone.map(m => m.lstProjectPlanActivity)).filter(f => parseInt(f.nID) === parseInt(nID));
        // let nBudget = lstData.map(m => parseInt(m.nBudget) || 0).reduce((a, b) => a + b, 0);
        // let nSum = nBudget;
        // arrDuration.forEach(f => {
        //     let nDiff = moment(formDuration.getValues(`sEndMonth_SpendingPlan_${f.nID}`)).diff(moment(formDuration.getValues(`sStartMonth_SpendingPlan_${f.nID}`)), "month");
        //     let nBudget = formDuration.getValues(`nBudget_SpendingPlan_${f.nID}`);
        //     if (!isNaN(nDiff) && nBudget) {
        //         nBudget = parseFloat(nBudget) * (nDiff + 1);
        //     }
        //     nSum += nBudget;
        // })
        //#endregion

        //#region เฉพาะกิจกรรม
        let nSum = 0;
        arrDuration.forEach(f => {
            let nDiff = moment(formDuration.getValues(`sEndMonth_SpendingPlan_${f.nID}`)).diff(moment(formDuration.getValues(`sStartMonth_SpendingPlan_${f.nID}`)), "month");
            let nBudget = 0;
            let _nBudget = parseFloatCheckValue(formDuration.getValues(`nBudget_SpendingPlan_${f.nID}`));
            if (!isNaN(nDiff) && _nBudget) {
                nBudget = (_nBudget * (nDiff + 1));
            }
            nSum += nBudget;
        })
        //#endregion

        if (nSum > nBudgetAll) {
            DialogFn.Warning("ผลรวมจำนวนเงินต่อเดือน ห้ามเกินงบประมาณกิจกรรม " + formatNumber(nBudgetAll, 2), () => {
                formDuration.setValue(`nBudget_SpendingPlan_${nID}`, null);
            }, () => {
                formDuration.setValue(`nBudget_SpendingPlan_${nID}`, null);
            });
        }
    }

    //// const OnCheckDuplicate = (date, clone) => {
    ////     let isDuplicate = false;
    ////     clone.forEach(item => {
    ////         let start = moment(formDuration.getValues("sStartMonth_SpendingPlan_" + item.nID)).startOf("month").year(nYear);
    ////         let end = moment(formDuration.getValues("sEndMonth_SpendingPlan_" + item.nID)).endOf("month").year(nYear);
    ////         if (start.isValid && end.isValid) {
    ////             let isBetween = date.isBetween(start, end, "month", "[]");
    ////             if (isBetween) {
    ////                 isDuplicate = true;
    ////                 return true;
    ////             }
    ////         }
    ////     });
    ////     return isDuplicate;
    //// }

    const OnCheckDuplicate = (date, clone, nID) => {
        let isDuplicate = false;
        clone.forEach(item => {
            let start = moment(formDuration.getValues("sStartMonth_SpendingPlan_" + item.nID)).startOf("month").year(nYear);
            let end = moment(formDuration.getValues("sEndMonth_SpendingPlan_" + item.nID)).endOf("month").year(nYear);
            if (start.isValid() && end.isValid()) 
            {
                // เริ่มต้น - สิ้นสุดของช่วงใหม่
                let newStart = moment(formDuration.getValues("sStartMonth_SpendingPlan_" + nID)).startOf("month").year(nYear);
                let newEnd = moment(formDuration.getValues("sEndMonth_SpendingPlan_" + nID)).endOf("month").year(nYear);
                // เงื่อนไขการทับซ้อนช่วง: ช่วงใหม่เริ่มก่อน end เดิม และสิ้นสุดหลัง start เดิม
                const isOverlap = newStart.isSameOrBefore(end) && newEnd.isSameOrAfter(start);
                if (isOverlap) {
                    isDuplicate = true;
                    return true;
                }
            }
        });
        return isDuplicate;
    };

    const handleOnChange = (e, nID, type) => {
        let isDuplicate = false;
        let clone = [...arrDuration].filter(f => f.nID !== nID);
        if (e) {
            let date = type === "start" ? moment(e).startOf("month").year(nYear) : moment(e).endOf("month").year(nYear);
            isDuplicate = OnCheckDuplicate(date, clone, nID);
            handleChangeBudget(nID);
            if (isDuplicate) {
                DialogFn.Warning("ช่วงเวลาซ้ำ");
                if (type === "start") {
                    formDuration.setValue("sStartMonth_SpendingPlan_" + nID, null);
                } else {
                    formDuration.setValue("sEndMonth_SpendingPlan_" + nID, null);
                }
                //// setnTrigger(nTrigger + 1);
                setnTrigger(v=> v + 1);
            }
        }
    }

    return (
        <Grid item xs={12} md={12} container spacing={2}>
            <FormProvider {...formDuration}>
                {(arrDuration ||[]).map((m, i) => {
                    return (
                        <Grid item container spacing={2} key={"key_duration_SpendingPlan_" + m.nID}>
                            <Grid item xs={12} md={7}>
                                <DateRangeProject
                                    NameStart={`sStartMonth_SpendingPlan_${m.nID}`}
                                    NameEnd={`sEndMonth_SpendingPlan_${m.nID}`}
                                    LabelStart={'เริ่มต้น'}
                                    LabelEnd={'สิ้นสุด'}
                                    IsMonthPicker={true}
                                    nID={m.nID}
                                    required={true}
                                    isDisableYear={true}
                                    nYearMapper={nYear}
                                    onChange={handleOnChange}
                                    minDate={dStart}
                                    maxDate={dEnd}
                                    nTrigger={nTrigger}
                                    disabled={!isPermission}
                                    formatDefault={"MMMM"}
                                    form={formDuration}
                                />
                            </Grid>
                            <Grid item xs={6} md={3}>
                                <InputNumberItem
                                    id={`nBudget_SpendingPlan_${m.nID}`}
                                    name={`nBudget_SpendingPlan_${m.nID}`}
                                    label={"จำนวนเงินต่อเดือน"}
                                    IsComma={true}
                                    IsAllowScientific={false}
                                    type={"Number"}
                                    ShowDigits={2}
                                    maxDigits={2}
                                    max={nBudgetAll}
                                    min={0}
                                    maxInteger={8}
                                    endAdornment={"บาท"}
                                    required={true}
                                    disabled={!isPermission}
                                    onChange={() => { handleChangeBudget(m.nID) }}
                                />
                                {/* <NumberInputCustom
                                    id={`nBudget_SpendingPlan_${m.nID}`}
                                    name={`nBudget_SpendingPlan_${m.nID}`}
                                    label={"จำนวนเงินต่อเดือน"}
                                    required={true}
                                    IsAllowScientific={false}
                                    maxDigits={2}
                                    ShowDigits={2}
                                    maxInteger={8}
                                    IsCanMinus={false}
                                    IsComma={true}
                                    max={nBudgetAll}
                                    min={0}
                                    endAdornment={"บาท"}
                                    disabled={!isPermission}
                                    onChange={() => { handleChangeBudget(m.nID) }}
                                /> */}
                            </Grid>
                            {isPermission &&
                                <Grid item xs={6} md={2}>
                                    <Grid container spacing={2}>
                                        {(arrDuration || []).length === i + 1 &&
                                            <Grid item>
                                                <BtnAdd
                                                    sColor="#00B393"
                                                    sColorHover="#009278"
                                                    id="AddDuration_SpendingPlan"
                                                    txt={'เพิ่มช่วงเวลา'}
                                                    IsCircleWithOutText
                                                    onClick={formDuration.handleSubmit((e) => onAddDuration(m.nActivityID),(err) => {
                                                        document.getElementById(Object.keys(err)[0])?.focus();
                                                        console.log("err", err)
                                                    })}
                                                />
                                            </Grid>
                                        }
                                        {(arrDuration || []).length > 1 &&
                                            <Grid item>
                                                <BtnDelete
                                                    sColorHover="#d30d1e"
                                                    id="DeleteDuration_SpendingPlan"
                                                    IsCircleWithOutText
                                                    onClick={() => onDeleteDuration(m.nID)}
                                                />
                                            </Grid>
                                        }
                                    </Grid>
                                </Grid>
                            }
                        </Grid>
                    )
                })}
            </FormProvider>
        </Grid>
    )
}